import LoadingDots from "../../../../components/Loading/LoadingDots";
import imgConsultant from "../../../../assets/consultant.svg";
import { useNavigate } from "react-router-dom";
import { TypeAnimation } from "react-type-animation";
import { useEffect, useState } from "react";
import CustomModal from "../../../../components/Modal/CustomModal";
import useSelectBrand from "../../../../hooks/styles/useSelectBrand";

const Loading = ({
  isOpen,
  onRequestClose,
  delayed,
  isOperating,

  handleConnectChatCancle,
}) => {
  const initialMessage = "안녕하세요, 지금부터 상담원이 직접 도와드리겠습니다.";
  const delay = 1000;

  const [sequenceArray, setSequenceArray] = useState([initialMessage, delay]);
  const [animationKey, setAnimationKey] = useState(0);
  const navigate = useNavigate();
  const { text } = useSelectBrand();
  // message가 있을 경우 sequenceArray를 업데이트
  useEffect(() => {
    if (isOperating?.message) {
      const newSequenceArray = [isOperating?.message, delay];
      setSequenceArray(newSequenceArray);
      setAnimationKey((prevKey) => prevKey + 1); // animationKey 업데이트
    } else if (delayed?.message) {
      const newSequenceArray = [initialMessage, delay, delayed?.message, delay];
      setSequenceArray(newSequenceArray);
      setAnimationKey((prevKey) => prevKey + 1); // animationKey 업데이트
    }
  }, [delayed, isOperating]);

  return (
    <>
      <CustomModal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        chatLoading
        contentLabel="디지털 상담 상담원 연결 Loading"
      >
        <p className="mb-5">
          <span className="relative px-10 py-6 rounded-[50px] inline-flex font-semibold bg-white text-zinc-600 after:block after:content-[''] after:absolute after:bottom-[-7px] after:w-4 after:h-4 after:bg-white after:rounded-sm after:left-1/3 after:rotate-45 break-all whitespace-pre-line">
            <TypeAnimation
              key={animationKey}
              sequence={sequenceArray}
              wrapper="span"
              speed={10}
              repeat={Infinity}
              deletionSpeed={30}
              cursor={false}
            />
          </span>
        </p>
        <p className="inline-flex justify-center mb-2.5">
          <img src={imgConsultant} alt="Consultant" />
        </p>
        <p className="text-xl font-semibold text-center mb-7">
          {`${text} 상담원과 연결 중입니다.`}
          <br /> 잠시만 기다려 주세요.
        </p>
        <LoadingDots white />

        <button
          className="font-medium leading-relaxed text-center text-white underline mt-7"
          onClick={() => {
            handleConnectChatCancle();
            navigate("/chat");
          }}
        >
          상담원 연결 취소
        </button>
      </CustomModal>
    </>
  );
};

export default Loading;
